import React from 'react';
import { gameLabel, ALL_GAMES } from '../lib/games';

// WO-20: game switcher for browse and search pages. Hidden while only one game is active (today: Pokemon), so pages
// look as before; appears by itself when WO-14 activates a second game.
// WO-26 (search): `allLabel` adds an "All games" tab first (value ALL_GAMES); `counts` ({game_id: n}) adds a count to
// each tab that has results.
export default function GameTabs({ game, games, onChange, className = '', allLabel = null, counts = null }) {
  if (!games || games.length < 2) return null;
  const tabs = allLabel ? [{ game_id: ALL_GAMES }, ...games] : games;
  const label = (id) => (id === ALL_GAMES ? allLabel : gameLabel(id, games));
  return (
    // WO-30: max-w-full + min-w-0 so six games scroll inside the row on phones instead of widening the page
    <div className={`flex gap-2 overflow-x-auto pb-1 max-w-full min-w-0 ${className}`} role="tablist" aria-label="Game">
      {tabs.map((g) => (
        <button
          key={g.game_id}
          type="button"
          role="tab"
          aria-selected={g.game_id === game}
          onClick={() => onChange(g.game_id)}
          data-testid={allLabel ? `game-${g.game_id}` : undefined}
          className={`h-8 px-3 rounded-full border text-sm whitespace-nowrap transition ${
            g.game_id === game ? 'bg-purple text-white border-purple' : 'border-purple/30 text-cream/80 hover:border-purple/60'
          }${counts ? ' inline-flex items-center gap-1.5' : ''}`}
        >
          {label(g.game_id)}
          {counts && counts[g.game_id] > 0 && (
            <span className={g.game_id === game ? 'text-white/70' : 'text-cream/40'}>{counts[g.game_id].toLocaleString()}</span>
          )}
        </button>
      ))}
    </div>
  );
}

// Pill row used for kind tabs (All / Cards / Sealed) and product-type filters.
export function PillTabs({ options, value, onChange, className = '', label = '' }) {
  return (
    <div className={`flex gap-2 overflow-x-auto pb-1 -mx-4 px-4 sm:mx-0 sm:px-0 ${className}`} role="tablist" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={o.value === value}
          data-testid={`tab-${o.value}`}
          onClick={() => onChange(o.value)}
          className={`h-8 px-3 rounded-full border text-sm whitespace-nowrap transition inline-flex items-center gap-1.5 ${
            o.value === value ? 'bg-purple text-white border-purple' : 'border-purple/30 text-cream/80 hover:border-purple/60 hover:text-cream'
          }`}
        >
          {o.label}
          {o.count != null && <span className={o.value === value ? 'text-white/70' : 'text-cream/40'}>{o.count.toLocaleString()}</span>}
        </button>
      ))}
    </div>
  );
}
